<app-waste-criteria-form (criteria)="onSearch($event)"></app-waste-criteria-form>
<app-waste-list #list [sorting]="sorting" (page)="onScroll()" (sort)="onSort($event)"></app-waste-list>
